import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
import { FaDollarSign, FaUserPlus, FaChartLine } from "react-icons/fa";
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import NotificationComponent from "../components/NotificationComponent/NotificationComponent";

const Notifications = () => {
  const tableTitle = "Others";

  const columns = ["Name", "Email", "Mobile", "CNIC", "Production", "Action"];
  const data = [
    {
      Name: "Alice",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Production: "3000kg",
      Approved: true,
    },
    {
      Name: "Bob",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Production: "3000kg",
      Approved: false,
    },
    {
      Name: "Charlie",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Production: "3000kg",
      Approved: true,
    },
    {
      Name: "Diana",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Production: "3000kg",
      Approved: false,
    },
  ];

  const handleEdit = (row) => {
    // Implement edit logic here (open a modal, navigate to edit page, etc.)
  };

  const handleDelete = (row) => {
    // Implement delete logic here (e.g., show a confirmation dialog, remove from state, etc.)
  };

  const handleDownload = (row) => {
    // Implement download logic here (e.g., download file or export row data)
  };

  // Pass dynamically if these features should be shown
  const showSearchBar = false; // Change to false to hide search bar
  const showFilter = false; // Change to false to hide filter
  const showTabs = false; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;
  const showCount = true;

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <NotificationComponent />
        </Col>
      </Row>
    </Container>
  );
};

export default Notifications;
